import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { JSXHelper } from "@/Common/Helpers/JSXHelper";
import { ConferenceRoom } from "@/Common/Models/Telemed/ConferenceRoom";

interface ConferenceRoomInformationProps {
    room: ConferenceRoom;
    openConferenceWindow: (room: ConferenceRoom, e: React.MouseEvent) => void;
}

class ConferenceRoomInformation extends BaseReactComponent<ConferenceRoomInformationProps> {
    public render(): JSX.Element {
        let styleGroup: React.CSSProperties = { paddingTop: "20px" };
        let styleLabel: React.CSSProperties = { textAlign: "right", display: "inline-block" };
        let styleValue: React.CSSProperties = { paddingLeft: "10px", display: "inline-block" };

        function formatAuthCode(code: string): string {
            return `${code.substr(0, 3)} ${code.substr(3)}`;
        }

        return (
            <div id="conferenceRoomInfo">
                <div className="conferenceRoomDisclaimer">
                    {JSXHelper.BreakStringIntoParagraphs(cacheStore.GetString("TelemedExistingRoomDisclaimer"))}
                </div>
                <div style={{ paddingLeft: "30px" }}>
                    <div style={styleGroup}>
                        <div style={styleLabel}>{cacheStore.GetString("TelemedLinkLabel")}</div>
                        <div style={styleValue}><a onClick={e => this.props.openConferenceWindow(this.props.room, e)}>{this.props.room.RoomUrl}</a></div>
                    </div>
                    <div style={styleGroup}>
                        <div style={styleLabel}>{cacheStore.GetString("TelemedActivationCodeLabel")}</div>
                        <div style={styleValue}> <b>{formatAuthCode(this.props.room.AuthCode)}</b></div>
                    </div>
                </div>
            </div>
        );
    }
}

export { ConferenceRoomInformation };
